import { fileTypeApi } from "@/main/api";
import { KeyValue } from "@/main/models/common";
import { Result } from "@/main/models/common/resultResponse";
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from "@/main/services/utils";
import { saveFileType } from "@/main/store/fileType/fileTypeActions";
import { GetFileType } from "@/main/store/fileType/fileTypeTypes";
import { AxiosError, AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";

export function* getFileTypeSaga(action: GetFileType) {
	try {
		const response: AxiosResponse<Result<KeyValue[]>> = yield call(
			fileTypeApi.getDomain,
			action.payload.idSystemApplication,
		);
		if (response.data.result) {
			yield put(saveFileType(response.data.result, false, null));
		}
	} catch (exception) {
		if (exception instanceof AxiosError) {
			const resultError = errorBoundaryReduxSaga(exception);
			renderErrorReduxSaga(resultError);
			yield put(saveFileType(null, true, resultError.messagesDataError));
		}
	}
}
